import React, { useState, useRef } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Button, Paper, MobileStepper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import photo01 from "./pictures/photo01.jpg";
// import photo02 from "./pictures/photo02.jpg";
import photo03 from "./pictures/photo03.jpg";
// import photo04 from "./pictures/photo04.jpg";
import photo06 from "./pictures/photo06.jpg";
import photo08 from "./pictures/photo08.jpg";
import Slide from '@material-ui/core/Slide';
import CustomModal from "./components/Modal/CustomModal";
// import { FormattedMessage } from "react-intl";
import logo from './pictures/logo.svg';

import _, { omit, pick, round, slice } from 'lodash';
import axios from "axios";
import Qs from "qs";
import { actions } from "./reducers/app";
import { useDispatch, useSelector } from "react-redux";
import PF from "./_Services/publicFunction";
import MyBackdrop from './components/BackDrop/BackDrop';
import Backdrop from "@material-ui/core/Backdrop";
import { indigo, green, red } from '@material-ui/core/colors';
// import GTranslateIcon from '@mui/icons-material/GTranslate';
import { FormattedMessage, injectIntl, intlShape, useIntl } from 'react-intl';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay, virtualize } from 'react-swipeable-views-utils';
import Swal from 'sweetalert2';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
// import virtualize from 'react-swipeable-views/lib/virtualize';
import { mod } from 'react-swipeable-views-core';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import RoomIcon from '@material-ui/icons/Room';
const AutoPlaySwipeableViews = autoPlay(virtualize(SwipeableViews));

const useStyles = makeStyles(theme => ({
  root: {
    // maxWidth: 600,
    flex: 1
  },
  media: {
    height: 620,
    width: "100%",
    objectFit: 'cover',
    // "-o-transition": "opacity 1s ease-in-out",
    transition: "opacity 2s ease-in-out"
    // paddingTop: '56.25%', // 16:9,"
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height: 620,
    // display: 'block',
    // maxWidth: 400,
    overflow: 'hidden',
    objectFit: 'cover',

    width: '100%',
  },

}));

function Login(props) {
  const { history } = props;
  const { i18n } = useSelector(state => ({
    i18n: state.app.i18n,
  }));

  const dispatch = useDispatch();
  const intl = useIntl();
  const formRef = React.createRef();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false)
  const [settingObj, setObj] = React.useState({
    UserName: { label: "姓名", name: "UserName", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, minLength: 2, maxLength: 50, pattern: "^[^0-9]+$", placeholder: "王小明" },
    birthDate: { label: "出生日期", name: "birthDate", type: "date", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, disableFuture: true, openTo: "year", placeholder: "2000/01/01" },
    personalId: { label: "身分證字號", name: "personalId", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, minLength: 8, maxLength: 10, placeholder: "A123456789" }
  })

  const handleTxtChange = e => {
    const { name, value } = e.target;
    setUser(prevstate => ({
      ...prevstate,
      [name]: value.trim()
    }));
  }
  React.useEffect(() => {
    //載入彈窗
    let timer;


    if (true) {
      timer = setInterval(() => {
        setDoor((prevProgress) =>
          prevProgress >= ArrayDoor.length - 1 ? 0 : prevProgress + 1
        );
      }, 5000);
    }

    return () => {
      clearInterval(timer);
    };
  }, [])
  const handleDateChange = (name, e, value) => {
    // console.log(e);
    console.log(value);
    setUser(prevstate => ({
      ...prevstate,
      [name]: value
    }));
  }
  const [user, setUser] = React.useState({
    birthDate: null
  })
  const [Bopen, setBOpen] = React.useState(false);
  const [IsShow, setIsShow] = React.useState(true);
  const handleToggle = () => {
    setBOpen(!Bopen);
  };
  const containerRef = useRef(null);
  const handleSubmit = e => {
    e.preventDefault();
    // if (user.UserName.toLowerCase() === "nopaper") {
    //   history.push(`${process.env.PUBLIC_URL}/NoPaper`);
    //   return
    // }
    if (validator()) {
      PF.instance({
        method: "post",
        url: PF.url + "/Login/Check",
        data: Qs.stringify({ parameter: user }),
      })
        .then(function (response) {
          const { TotalRecord, rows, token, UserInfo } = response.data;
          // console.log(UserInfo);
          const doneQ = rows.reduce((a, b) => (b.QuestionNo !== null ? a + 1 : a), 0)
          const beingQ = rows.filter(item => { return item.QuestionNo === null ? true : false })


          // console.log(beingQ);
          // console.log(TotalRecord);
          if (TotalRecord === 0) {
            // alert("抱歉,查無您的預約資料\r\n請致電 04-2255-2555 #168 企業健檢預約查詢")
            alert(intl.formatMessage({ id: "app.LoginCantFound" }));
            setUser({
              UserName: null, birthDate: null, personalId: null, BarCodeStr: '',
            });

          } else if (TotalRecord === doneQ && rows[0].SpecialCheckDate !== null) {
            // alert("您所需要填寫的問卷均已提交，謝謝")
            alert(intl.formatMessage({ id: "app.AllQuestsDone" }))

          } else if (TotalRecord === doneQ && rows[0].SpecialCheckDate === null) {
            let isconfirm = window.confirm("您所需要填寫的問卷均已完成，使否需要修改?");
            if (isconfirm) {

              sessionStorage.setItem("token", JSON.stringify(token));
              dispatch(actions.token(token));
              dispatch(actions.UserInfo(UserInfo));
              history.push(`${process.env.PUBLIC_URL}/Admin`);
            }
          } else if (TotalRecord > doneQ) { //尚有未完成問卷
            sessionStorage.setItem("token", JSON.stringify(token));
            dispatch(actions.token(token));
            dispatch(actions.UserInfo(UserInfo));
            dispatch(actions.QUESTS_SET(beingQ));
            setIsShow(!IsShow)
            Swal.fire({
              title: '勞檢表',
              html:
                // '<span style="color: red;">需要</span>勞檢表，請選<span style="color: red;">需要</span><br/>(<strong>企業員工團體健檢</strong>必選或需提供勞工體檢表給公司)<br/>' +
                // '<span style="color: red;">不需</span>勞檢表，請選<span style="color: red;">不需要</span><br/>(不需要提供勞檢表給公司)<br/><br/>' +
                // '<span style="color: red;">公司員工眷屬</span>或<span style="color: red;">個人健檢</span><strong>需要</strong>勞檢表，填寫完請告知櫃台人員<br/>'+

                '<strong>1.<u>企業合作方案</u>，請務必選擇<span style="color: red;">需要</span>，診所將統一提供給企業承辦。</strong><br/><strong>2.<u>個人健檢、企業合作員工方案眷屬</u>，需提供勞檢表給公司請選擇<span style="color: red;">需要</span>。</strong><br/><br/><strong>無申請勞檢表需求可填<span style="color: red;">不需要</span>，即可減少填寫時間。</strong>'

              ,

              icon: 'info',
              showCancelButton: true,
              confirmButtonText: '需要',//相反
              cancelButtonText: '不需要',
              reverseButtons: true,
              allowOutsideClick: false,

            }).then((result) => {
              if (result.isConfirmed) {
                const confirmed = (true)
                dispatch(actions.Confirme(confirmed));
                history.push(`${process.env.PUBLIC_URL}/Admin`);

              } else if (result.dismiss === Swal.DismissReason.cancel) {
                const confirmed = (false)
                dispatch(actions.Confirme(confirmed));
                history.push(`${process.env.PUBLIC_URL}/Admin`);

              }
            });
            setUser({
              UserName: null, birthDate: null, personalId: null, BarCodeStr: '',
            });
          }
        })
    }

  }
  const validator = () => {
    const form = formRef.current; //參數1

    if (form.checkValidity()) {
      console.log("全部通過");
      for (let i = 0; i < form.elements.length; i++) {
        const element = form.elements[i];
        if (Object.keys(settingObj).includes(element.name)) {
          setObj(prevState => ({
            ...prevState,
            [element.name]: omit(prevState[element.name], ["error"])
          }))
        }
      }
      return true;
    } else {
      for (let i = 0; i < form.elements.length; i++) {
        const element = form.elements[i];
        if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
          if (Object.keys(settingObj).includes(element.name)) {
            setObj(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: intl.formatMessage({ id: element.validationMessage }) }
            }))
          }
          // console.log(element.validationMessage)

        } else {//驗證通過，自訂訊息
          //有在settingObj的
          if (Object.keys(settingObj).includes(element.name)) {
            setObj(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }

        }
      }
      return false;
    }
  }
  const ArrayDoor = [photo01, photo06, photo03, photo08]
  const [door, setDoor] = React.useState(0);


  return (
    <React.Fragment>
      <Card>
        <CardActionArea onClick={() => { setOpen(true); }}>
          {/* <CardMedia
            className={classes.media}
            component='img'
            image={ArrayDoor[door]}
          /> */}
          <SwipeableTextMobileStepper className={classes.media} />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2" style={{ color: "black", fontWeight: "700" }}>
              <FormattedMessage id={"晨悅預防醫學"} />
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p" style={{ marginLeft: "20px", color: "#F2781F", fontWeight: "bold" }}>
              <FormattedMessage id={"健康人生，攜手晨悅"} />
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary" variant="contained" style={{ backgroundColor: indigo[500] }}>
            <a href="https://www.mornjoy.com.tw/" style={{ textDecoration: "none", color: "white" }}>WebSite</a>
          </Button>
          <Button size="small" color="primary" variant="contained" style={{ backgroundColor: indigo[500] }}>
            <a href="http://mj.mornjoy.com.tw/EBook/index.html" style={{ textDecoration: "none", color: "white" }}>e-Book</a>
          </Button>
          <Button size="small" color="primary" variant="contained" style={{ backgroundColor: indigo[500] }}>
            <a href="https://goo.gl/maps/w7oP8xanRMfPV7vMA" style={{ textDecoration: "none", color: "white" }}><RoomIcon fontSize="small" style={{ color: red[700] }} />Google Map</a>
          </Button>
          <Button size="small" color="primary" variant="contained" style={{ backgroundColor: indigo[500] }}>
            <a href="tel:04-22552555" style={{ textDecoration: "none", color: "white" }}><AddIcCallIcon style={{ color: green[500] }} fontSize="small" /></a>
          </Button>
        </CardActions>
      </Card>
      <div className="container" ref={containerRef}></div>
      {IsShow && (
        <CustomModal open={true} setOpen={setOpen} logo={logo} settingObj={Object.values(settingObj)}
          handleDateChange={handleDateChange}
          handleTxtChange={handleTxtChange}
          formRef={formRef}
          data={user}
          handleSubmit={handleSubmit}
        />
      )}
    </React.Fragment>
  );
}

const tutorialSteps = [
  {
    imgPath: photo01,
  },
  {
    imgPath:
      photo03,
  },
  {
    imgPath:
      photo06,
  },
  {
    imgPath:
      photo08,
  },

];

const styles = {
  slide: {
    padding: 15,
    minHeight: 100,
    color: '#fff',
  },
  img: {
    height: 620,
    // display: 'block',
    // maxWidth: 400,
    overflow: 'hidden',
    objectFit: 'cover',

    width: '100%',
  },
}


function SwipeableTextMobileStepper() {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = tutorialSteps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  const SlideRenderer = params => {
    // const classes = useStyles();
    const { index, key } = params;

    switch (mod(index, 4)) {
      case 0:
        return (<img key={key} src={tutorialSteps[0].imgPath} className={classes.img} />);
      case 1:
        return (<img key={key} src={tutorialSteps[1].imgPath} className={classes.img} />);
      case 2:
        return (<img key={key} src={tutorialSteps[2].imgPath} className={classes.img} />);
      case 3:
        return (<img key={key} src={tutorialSteps[3].imgPath} className={classes.img} />);
      default:
        return null;
    }
  }


  return (
    <div className={classes.root}>
      <AutoPlaySwipeableViews
        // axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        // index={activeStep}
        // onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={5000}
        slideRenderer={SlideRenderer}
      // className={classes.img}
      >

      </AutoPlaySwipeableViews>
      {/* <MobileStepper
        steps={maxSteps}
        position="static"
        variant="text"
        activeStep={activeStep}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
        }
      /> */}
    </div>
  );
}

export default injectIntl(Login);